import React, { useState } from 'react';

// Modal for displaying Income Details
const IncomeModal = ({ isOpen, onClose, income }) => {
  if (!isOpen) return null;
  
  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <h3>Income Details</h3>
        <p><strong>Income:</strong> {income}</p>
        <button style={closeButtonStyle} onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

const MemberwiseIncome = () => {
  const [search, setSearch] = useState('');
  const [entries, setEntries] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIncome, setSelectedIncome] = useState(null);

  const memberData = [
    { srNo: 1, name: 'AKANKSHA KUSHWAHA', mobile: '9044750234', email: 'akankshakushwaha482@gmail.com', invitationMobile: '9795225773', invitationName: 'DEEPANKAR KUSHWAHA', regDate: '17-11-2024 12:35:53 AM', status: 'INACTIVE', kycStatus: 'ACTIVE', income: '5000' },
    { srNo: 2, name: 'DEVENDRA SINGH', mobile: '8840530382', email: 'chandeldevesh@gmail.com', invitationMobile: '9795225773', invitationName: 'DEEPANKAR KUSHWAHA', regDate: '28-09-2024 03:57:56 PM', status: 'INACTIVE', kycStatus: 'ACTIVE', income: '4000' },
    { srNo: 3, name: 'IQBAL SINGH', mobile: '9855300087', email: 'kauraish2005@gmail.com', invitationMobile: '9795225773', invitationName: 'DEEPANKAR KUSHWAHA', regDate: '10-09-2024 08:13:46 PM', status: 'INACTIVE', kycStatus: 'ACTIVE', income: '3500' },
    { srNo: 4, name: 'AJAY KUMAR', mobile: '7366016111', email: 'synergyfinancial15@gmail.com', invitationMobile: '9990667666', invitationName: 'PAWAN YADAV', regDate: '29-08-2024 06:55:59 PM', status: 'INACTIVE', kycStatus: 'ACTIVE', income: '3000' },
    // Add other member data here...
  ];

  // Filter member data based on search query
  const filteredMembers = memberData.filter((member) => {
    return (
      member.name.toLowerCase().includes(search.toLowerCase()) ||
      member.mobile.includes(search) ||
      member.email.toLowerCase().includes(search)
    );
  });

  // Slice the filtered list to show only the specified number of entries
  const displayedMembers = filteredMembers.slice(0, entries);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleViewIncome = (income) => {
    setSelectedIncome(income);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Styling
  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '6px',
    textAlign: 'left',
    fontSize: '12px', // Smaller font size
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
    fontSize: '13px', // Smaller font size for headers
  };

  const inputStyle = {
    padding: '6px',
    fontSize: '12px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginBottom: '20px',
    width: '200px',
  };

  const buttonStyle = {
    padding: '6px 12px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px', // Smaller font size
  };

  const hoverRowStyle = {
    backgroundColor: '#f1f1f1',
  };

  const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const modalContentStyle = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    width: '300px',
    textAlign: 'center',
  };

  const closeButtonStyle = {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    cursor: 'pointer',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}></h2>

      <div style={{ textAlign: 'center' }}>
        <label>Show </label>
        <select onChange={(e) => setEntries(Number(e.target.value))} value={entries}>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
        <label> entries</label>

        <br />
        <input
          type="text"
          value={search}
          onChange={handleSearchChange}
          placeholder="Search"
          style={inputStyle}
        />
      </div>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr. No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Email</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Invitation Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Invitation Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Reg. Date</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Status</th>
            <th style={{ ...thTdStyle, ...thStyle }}>KYC Status</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Income</th>
          </tr>
        </thead>
        <tbody>
          {displayedMembers.map((member) => (
            <tr
              key={member.srNo}
              style={{ ...thTdStyle, cursor: 'pointer' }}
              onClick={() => handleViewIncome(member.income)}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#f9f9f9')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '')}
            >
              <td>{member.srNo}</td>
              <td>{member.name}</td>
              <td>{member.mobile}</td>
              <td>{member.email}</td>
              <td>{member.invitationMobile}</td>
              <td>{member.invitationName}</td>
              <td>{member.regDate}</td>
              <td>{member.status}</td>
              <td>{member.kycStatus}</td>
              <td>
                <button style={buttonStyle} onClick={() => handleViewIncome(member.income)}>
                  View Income
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      <IncomeModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        income={selectedIncome}
      />
    </div>
  );
};

export default MemberwiseIncome;
